import { Injectable }     from '@angular/core';
import { CanActivate, Router }    from '@angular/router';
import { TicketService } from './Ticket/Services/ticket.service';

@Injectable()
export class PaymentGuard implements CanActivate {
    
    client: {};
    domainErrorMessage: string;
    
    constructor(private router: Router, private ticketService: TicketService){
    }  

    canActivate() {

        return new Promise(resolve => {

            this.ticketService.getClientData().subscribe(result => {
                this.client = result;
                this.ticketService.client = result;
                
                if(result.error == true){
                    this.router.navigate(['/404']);
                    resolve(false);
                }
                
                if (!this.ticketService.ticket_data) {
                    this.router.navigate(['/ticket-search']);
                    resolve(false);
                }

                resolve(true);
            }, error => {

                this.router.navigate(['/500']);
                resolve(false);
            });
        });
    }  
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/payment-guard.service.ts